import { Helmet } from 'react-helmet';
import { ReportCoverLetterContainer } from '../components/report-cover-letter.container';

export const ToolsReportCoverLetter: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Tools - Report Cover Letter</title>
      </Helmet>
      <ReportCoverLetterContainer />
    </>
  );
};
